/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_POS_INTERVAL_STATS = gql`
  query GetPosIntervalStats($filters: PosIntervalFilter!) {
    posIntervalStats(filters: $filters) {
      period
      results {
        label
        date
        value
      }
    }
  }
`
